import React from 'react'
import useTranslation from 'next-translate/useTranslation'
import GiftIcon from '@ancon/wildcat-ui/shared/icons/gift-outline.svg'

import Button from '../../app/components/Button'
import useAppSelector from '../../../store/hooks/useAppSelector'
import { giftCardsSellOnlineIsActiveSelector } from '../../giftCards/store/giftCardsSelectors'
import useAppStore from '../../../store/hooks/useAppStore'
import useAppDispatch from '../../../store/hooks/useAppDispatch'
import { checkoutCurrentCheckoutIdSelector } from '../../checkout/store/checkoutSelectors'
import { checkoutSetSystemProductWarningModalVisible } from '../../checkout/store/checkoutSlice'
import { CheckoutSystemProductWarningType } from '../../checkout/types'
import useNavigateGiftCardPurchase from '../../giftCards/hooks/useNavigateGiftCardPurchase'

import styles from './OutletPurchaseGiftCardButton.module.scss'

export default function OutletPurchaseGiftCardButton() {
  const { t } = useTranslation('outlet')

  const store = useAppStore()

  const dispatch = useAppDispatch()

  const navigateGiftCardPurchase = useNavigateGiftCardPurchase()

  const sellGiftCardsOnline = useAppSelector(
    giftCardsSellOnlineIsActiveSelector,
  )

  function handleClick() {
    const checkoutId = checkoutCurrentCheckoutIdSelector(store.getState())

    if (checkoutId) {
      // Show warning modal if there's an existing checkout
      dispatch(
        checkoutSetSystemProductWarningModalVisible(
          CheckoutSystemProductWarningType.StartGiftCardPurchase,
        ),
      )
      return
    }

    navigateGiftCardPurchase()
  }

  if (!sellGiftCardsOnline) {
    return null
  }

  return (
    <Button
      variant="primary"
      onClick={handleClick}
      className={styles.purchaseGiftCardButton}
      outlined
    >
      <GiftIcon />
      <span>{t('purchaseGiftCard')}</span>
    </Button>
  )
}
